import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RequestService } from 'src/app/services/requests.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as nations from '../../../files/countries.json';

@Component({
  selector: 'app-biological-data-upload',
  templateUrl: './biological-data-upload.component.html',
  styleUrls: ['./biological-data-upload.component.scss']
})
export class BiologicalDataUploadComponent implements OnInit {
  uploadForm: FormGroup;
  pilots = ['Maize', 'Poultry', 'Fish', 'Beef'];
  domains = ['Farm', 'Fishery', 'Poultry', 'Cattle', 'SlaughterHouse', 'Distributor', 'Processor', 'Retailer'];
  typesOfAnalysis = ['Plate count method', 'PCR', 'REAL TIME PCR', 'ELISA', 'Conventional method EN ISO 6579-1', 'Conventional method NF EN ISO 10272-1',
                     'Conventional method NF EN ISO 16654', 'Conventional method EN ISO 6579-1', 'Conventional microbiology', 'Molecular', 'FC (Flow cytometer)', 'Other'];
  files: any[] = [];
  partners = [
    {
      no: 1,
      name: 'Geoponiko Panepistimio Athinon',
      abbreviation: 'AUA',
      country: 'Greece',
    },
    {
      no: 2,
      name: 'Cranfield University',
      abbreviation: 'CU',
      country: 'United Kingdom',
    },
    {
      no: 3,
      name: 'Shandong Agricultural University',
      abbreviation: 'SDAU',
      country: 'China',
    },
    {
      no: 4,
      name: 'Universita Degli Studi Di Napoli Federico II',
      abbreviation: 'UNINA',
      country: 'Italy',
    },
    {
      no: 5,
      name: 'Wings ICT Solutions Information & Communication Technologies IKE',
      abbreviation: 'WINGS',
      country: 'Greece',
    },
    {
      no: 6,
      name: 'Nanjing Agricultural University',
      abbreviation: 'NAU',
      country: 'China',
    },
    {
      no: 7,
      name: 'Videometer AS',
      abbreviation: 'VIDEOM',
      country: 'Denmark',
    },
    {
      no: 8,
      name: 'Texnologies Fotonikon Kai Hlektronikon Systhmatwn AE',
      abbreviation: 'THETA',
      country: 'Greece',
    },
    {
      no: 9,
      name: 'University of Shanghai for Science and Technology',
      abbreviation: 'USST',
      country: 'China',
    },
    {
      no: 10,
      name: 'Univeristy College Dublin National University of Ireland, Dublin',
      abbreviation: 'UCD',
      country: 'Ireland',
    },
    {
      no: 11,
      name: 'Centaur Technologies IKE',
      abbreviation: 'Centaur',
      country: 'Greece',
    },
    {
      no: 12,
      name: 'Zhejiang University',
      abbreviation: 'ZJU',
      country: 'China',
    },
    {
      no: 13,
      name: 'FA Food Allergens Lab LTD',
      abbreviation: 'FOODAL',
      country: 'Cyprus',
    },
    {
      no: 14,
      name: 'Kotino Anonymi Pthnotrofiki Emporiki kai Viomichaniki Epixeirhsh AEVE',
      abbreviation: 'KOTINO',
      country: 'Greece',
    },
    {
      no: 15,
      name: 'Fudan University',
      abbreviation: 'FUDAN',
      country: 'China',
    },
    {
      no: 16,
      name: 'Universiteit Maastricht',
      abbreviation: 'UMAAS',
      country: 'Netherlands',
    },
    {
      no: 17,
      name: 'Ministry of Health of the Republic of Cyprus',
      abbreviation: 'SGL',
      country: 'Cyprus',
    },
    {
      no: 18,
      name: 'Yellow Sea Fisheries Research Institute, Chinese Academy of Fishery Sciences',
      abbreviation: 'YSFRI',
      country: 'China',
    },
    {
      no: 19,
      name: 'Apostolos Papadopoulos kai SIA OE',
      abbreviation: 'PAP',
      country: 'Greece',
    },
    {
      no: 20,
      name: 'Yiotis Anonimos Emporiki kai Viomixaniki Etaireia',
      abbreviation: 'YIOTIS',
      country: 'Greece',
    },
    {
      no: 21,
      name: 'Institute of Quality Standards & Testing Technology For Agro-products, Chinese Academy of Agricultural Sciences',
      abbreviation: 'CAAS',
      country: 'China',
    },
    {
      no: 22,
      name: 'Ellininos Georgikos Organismos-Dimitra',
      abbreviation: 'HAO',
      country: 'Greece',
    },
    {
      no: 23,
      name: 'Adiv Association',
      abbreviation: 'ADIV',
      country: 'France',
    },
    {
      no: 24,
      name: 'China Agricultural University',
      abbreviation: 'CAU',
      country: 'China',
    },
    { no: 25, name: 'Wirelessinfo', abbreviation: 'WRLS', country: 'Czechia' },
    {
      no: 26,
      name: 'Aristoteleio Panepisthmio Thessalonikis',
      abbreviation: 'AUTH',
      country: 'Greece',
    },
    {
      no: 27,
      name: 'Innews Cyprus LTD',
      abbreviation: 'INNEWS',
      country: 'Cyprus',
    },
    {
      no: 28,
      name: 'Glanbia Ireland Designated Activity Company',
      abbreviation: 'Glanbia',
      country: 'Ireland',
    },
    {
      no: 29,
      name: 'Sichuan University',
      abbreviation: 'SCU',
      country: 'Chine',
    },
    {
      no: 30,
      name: 'Shandong New Hope Liuhe LLC',
      abbreviation: 'HOPE',
      country: 'China',
    },
    {
      no: 31,
      name: 'Nemis Technologies AG',
      abbreviation: 'NEMIS',
      country: 'Switzerland',
    },
    {
      no: 32,
      name: 'Shandong Minhe Animal Husbandry CO.LTD',
      abbreviation: 'MINHE',
      country: 'China',
    },
    {
      no: 33,
      name: 'Inner Mongolia Kerchin Cattle Industry CO.LTD',
      abbreviation: 'KERCHIN',
      country: 'China',
    },
  ];
  countries: any[] = [];

  constructor(private formBuilder: FormBuilder, private req: RequestService<any>) { }

  ngOnInit(): void {
    this.uploadForm = this.formBuilder.group({
      title: [''],
      shortDescription: [''],
      generationDate: [''],
      completedDate: [''],
      partner: [''],
      country: [''],
      ditectPilot: [''],
      laboratory: [''],
      domain: [''],
      analysisType: [''],
      measurement: [''],
      unit: ['']
    });
    this.countries = nations.countries;
  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  refresh() {
    Swal.fire(
      'Done!',
      'File successfully uploaded!',
      'success'
    ).then(() => window.location.reload())

  }

  submitForm() {
    let dataObj: any;
    dataObj = {
      titleOfDocument: this.uploadForm.value.title,
      shortDescription: this.uploadForm.value.shortDescription,
      country: this.uploadForm.value.country,
      partner: this.uploadForm.value.partner,
      domain: this.uploadForm.value.domain,
      pilotCode: this.uploadForm.value.ditectPilot,
      laboratory: this.uploadForm.value.laboratory,
      createdDate: new Date(this.uploadForm.value.generationDate).toISOString(),
      completedDate: new Date(this.uploadForm.value.completedDate).toISOString(),
      measurement: this.uploadForm.value.measurement,
      unit: this.uploadForm.value.unit,
      fileName: this.files[0].name,
      type: 'biological',
    };
    const formData: FormData = new FormData();
    formData.append('file', this.files[0]);
    formData.append(
      'meta',
      new Blob([JSON.stringify(dataObj)], {
        type: 'application/json',
      })
    );
    this.req
      .postFile(formData)
      .subscribe(
        (error) => console.log(error)
      );
    this.refresh();
  }
}

